const MAX_CACHE_TTL_LENGTH = 6;
const MAX_FAILURE_THRESHOLD_LENGTH = 3;
const MAX_RETRY_AFTER_LENGTH = 6;

export {
  MAX_CACHE_TTL_LENGTH,
  MAX_FAILURE_THRESHOLD_LENGTH,
  MAX_RETRY_AFTER_LENGTH,
};
